import { FileImageOutlined } from 'farmhub-ui-core';

import { theme } from 'styled';

import { Wrapper } from './styles';

interface ImgSkeletonProps {
  width: number;
  height: number;
}

const ImgSkeleton = ({ width, height }: ImgSkeletonProps): JSX.Element => (
  <Wrapper height={height} width={width}>
    <FileImageOutlined
      style={{ fontSize: '30px', color: theme.colors.icon.secondary }}
    />
  </Wrapper>
);

export default ImgSkeleton;
